module.exports = __webpack_public_path__ + "static/media/备案图标.d0289dc0.png";